export const datosCertificacionInicial = {
  fecha: Date.now(),
  tipoSolicitud: "",
  telefono: "",
  correo: "",
  medicoPrescriptor: "",
  comentarios: "",
  diagnostico: ""
};
